import request from "_private/utils/request";
// let mock = "/mock/5c7fb1b653377c002106962b";
let mock = "";

/**
 * @description 获取报警Cnt
 * @author zhanglu
 * @export
 * @returns
 */
const FetchAlarmCnt = function () {
    return requestAjax({
        url: mock + "/message/getTodayAlarmCount",
        method: "post"
    });
};
/**
 * @description 获取消息Cnt
 * @author zhanglu
 * @export
 * @returns
 */
const FetchMsgCnt = function () {
    return requestAjax({
        url: mock + "/message/getTodayMsgCount",
        method: "post"
    });
};
/**
 * @description 获取报警List
 * @author zhanglu
 * @export
 * @returns
 */
const FetchAlarmList = function () {
    return requestAjax({
        url: mock + "/message/getTodayAlarmDetail"
    });
};
/**
 * @description 获取消息List
 * @author zhanglu
 * @export
 * @returns
 */
const FetchMsgList = function () {
    return requestAjax({
        url: mock + "/message/getTodayMsgDetail"
    });
};

// 主动安全
const handleAlarm_safe_Api = function (data) {
    return requestAjax({
        url: "/monitorCenter/monitor/saveADASHandle",
        data
    });
};

// 报警处理
const handleAlarm_Api = function (data) {
    return request({
        url: "/report/processing/saveAlarmProcessingReportForm",
        method: "post",
        data
    });
};

const ignoreAlarm_Api = function (data) {
    return request({
        url: "/report/processing/changeStatus",
        method: "post",
        data
    });
};

const requestAjax = function (rOpts) {
    let opts = {
        url: "",
        method: "post",
        headers: {type: "json"},
        data: {}
    };
    opts = Object.assign(opts, rOpts);
    return request({
        url: mock + opts.url,
        method: opts.method,
        headers: opts.headers,
        data: opts.data
    });
};

export default {
    FetchAlarmCnt,
    FetchMsgCnt,
    FetchAlarmList,
    FetchMsgList,
    handleAlarm_safe_Api,
    handleAlarm_Api,
    ignoreAlarm_Api
};
